module.exports = __webpack_public_path__ + "img/infotechnology.b8474797.jpg";